if (!customElements.get('sr-sticky-cart')) {
  customElements.define('sr-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.main = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
      if (!this.main) return;
      this.add = this.querySelector('[data-sr-add]');
      this.update = () => {
        this.add.disabled = this.main.disabled || this.main.getAttribute('aria-disabled') === 'true';
        const label = this.main.querySelector('span');
        if (label) this.add.textContent = label.textContent.trim();
        const price = document.getElementById(`price-${this.dataset.section}`);
        const amount = price?.querySelector('.price--on-sale .price-item--sale') || price?.querySelector('.price-item--regular');
        if (amount) this.querySelector('[data-sr-price]').textContent = amount.textContent.trim();
      };
      this.add.addEventListener('click', () => { if (!this.main.disabled) this.main.click(); });
      this.observer = new IntersectionObserver(entries => { const e = entries[0]; this.hidden = e.isIntersecting || e.boundingClientRect.top > 0; }, {threshold: 0});
      this.observer.observe(this.main);
      this.mutation = new MutationObserver(this.update);
      this.mutation.observe(this.main, {attributes: true, childList: true, subtree: true});
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) this.mutation.observe(price, {childList: true, subtree: true});
      this.update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.mutation?.disconnect(); }
  });
}
